import './src/css/global.css';
import React from 'react';
import './src/components/storyblok/storyblok-bridge';
import { SlugProvider } from './src/contexts/SlugContext';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import { scheduleNonCriticalTask } from './src/lib/utils';

const queueConsentTrackers = (locationLike) => {
  if (typeof window === 'undefined') return;

  scheduleNonCriticalTask(() => {
    initializeAndTrack(locationLike || window.location);
  }, { timeout: 3000 });
};

// Unregister stale service workers so users receive fresh deploys.
export const onClientEntry = () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => registration.unregister());
  });

  queueConsentTrackers(window.location);
};

export const onRouteUpdate = ({ location }) => {
  queueConsentTrackers(location);
};

export const disableCorePrefetching = () => true;

export const shouldUpdateScroll = ({ routerProps }) => {
  const { pathname, hash } = routerProps.location;

  if (hash) {
    return decodeURI(hash);
  }

  if (pathname.startsWith('/blog') || pathname.startsWith('/en/blog')) {
    return [0, 0];
  }

  return true;
};

export const wrapRootElement = ({ element }) => (
  <SlugProvider>{element}</SlugProvider>
);
